import { render } from "./MarkDownView.vue?vue&type=template&id=481b4992&scoped=true"
import script from "./MarkDownView.vue?vue&type=script&lang=js"
export * from "./MarkDownView.vue?vue&type=script&lang=js"

import "./MarkDownView.vue?vue&type=style&index=0&id=481b4992&scoped=true&lang=css"
import "./MarkDownView.vue?vue&type=style&index=1&id=481b4992&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-481b4992"]])

export default __exports__